.yAxis-label {
  font-size: 24px;
  text-anchor: middle;
}
